import { ReactNode } from 'react'

import {
  IconArrowRightArrowLeft,
  IconLongArrowLeft,
  IconLongArrowRight
} from '@smartbear/swagger-portal-component-library'
import { clsx } from 'clsx'

export type StreamingType = 'unary' | 'server' | 'client' | 'bidirectional'

export interface StreamingBadgeProps {
  type?: StreamingType,
  children: ReactNode,
  className?: string,
}

interface BadgeConfig {
  styles: string,
  iconStyles: string,
  icon?: ReactNode,
}

const BADGE_CONFIG: Record<StreamingType, BadgeConfig> = {
  unary: {
    styles: 'bg-[#EDEDED] border-[#D1D1D1] dark:bg-[#3C3C3C] dark:border-[#515151]',
    iconStyles: 'text-[#646464] dark:text-[#A7A7A7]',
  },
  server: {
    styles: 'bg-[#DAEAFB] border-[#A6E0FE] dark:bg-[#003161] dark:border-[#005987]',
    iconStyles: 'text-[#006EDC] dark:text-[#4AA5FF]',
    icon: <IconLongArrowRight />,
  },
  client: {
    styles: 'bg-[#F2EDFD] border-[#D8C4FF] dark:bg-[#2D155C] dark:border-[#522E9B]',
    iconStyles: 'text-[#803EC2] dark:text-[#B18AFF]',
    icon: <IconLongArrowLeft />,
  },
  bidirectional: {
    styles: 'bg-[#FFEDCF] border-[#F0D8AF] dark:bg-[#3E0F07] dark:border-[#6E4600]',
    iconStyles: 'text-[#AB4019] dark:text-[#E7824C]',
    icon: <IconArrowRightArrowLeft />,
  },
}

export const StreamingBadge = ({
  type,
  children,
  className,
}: StreamingBadgeProps) => {
  const { styles, iconStyles, icon } = (type && BADGE_CONFIG[type]) ?? BADGE_CONFIG.unary

  return (
    <span
      data-testid="streaming-badge"
      className={clsx(
        'inline-flex items-center gap-1 px-2 py-1 border text-body3 text-[#1C2022] dark:text-[#FFFFFF] font-medium h-6 rounded-[4px]',
        styles,
        className
      )}
    >
      {icon ? <span className={clsx('inline-flex shrink-0', iconStyles)}>{icon}</span> : null}
      {children}
    </span>
  )
}
